import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetsModule } from '@geoanalitika/widgets/dist/lib';
import { AlertModule } from 'ngx-bootstrap/alert';
import {
  AlertBuilderComponent,
  AlertComponent,
  FilterComponent,
  MapComponent,
  RoundCheckboxComponent
} from './components';
import { ClickOutsideDirective, FocusDirective, PikadayDirective } from './directives';
import { KeysPipe, ReversePipe } from './pipes';
import { AlertService, SubscribeService } from './services';

const DECLARATIONS = [
  FocusDirective,
  MapComponent,
  ClickOutsideDirective,
  PikadayDirective,
  ReversePipe,
  KeysPipe,
  FilterComponent,
  AlertComponent,
  AlertBuilderComponent,
  RoundCheckboxComponent
];

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, WidgetsModule, AlertModule.forRoot()],
  declarations: DECLARATIONS,
  providers: [
    SubscribeService,
    // this has to be a singleton
    AlertService
  ],
  exports: [...DECLARATIONS, CommonModule, WidgetsModule, FormsModule, ReactiveFormsModule, AlertModule, AlertBuilderComponent],
  entryComponents: [AlertBuilderComponent]
})
export class SharedModule {}
